import { render, staticRenderFns } from "./AddDocumentTypeToChecklist.vue?vue&type=template&id=32d3c9ce&scoped=true&"
import script from "./AddDocumentTypeToChecklist.vue?vue&type=script&lang=js&"
export * from "./AddDocumentTypeToChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d3c9ce",
  null
  
)

export default component.exports